import {getCards, getWorkingUser, getTimeSpentProjects, chartActivity, chartActivitySingleUser} from "../../../api/admin/admin";
const state = () => ({
    cards: [],
    workingUsers: [],
    timeSpentProjects: [],
    chart_activity: {},
    singleUserChart: {},
    projectReport: {},
})

const getters = {
    get_cards(state){
        return state.cards;
    },
    get_workingUsers(state){
        return state.workingUsers;
    },
    get_timeSpentProjects(state){
        return state.timeSpentProjects;
    },
    get_chartActivity(state){
        return state.chart_activity
    },
    get_singleUserChart(state){
        return state.singleUserChart
    },
    get_projectReport(state){
        return state.projectReport
    },
}

const mutations = {
    SET_CARDS (state, data) {
        state.cards = data;
    },
    SET_WORKINGUSERS (state, data) {
        state.workingUsers = data;
    },
    SET_TIMESPENTPROJECCTS(state, data){
        return state.timeSpentProjects = data;
    },
    SET_CHARTACTIVITY(state, data){
        state.chart_activity = data
    },
    SET_SINGLEUSERCHART(state, data){
        state.singleUserChart = data
    },
    SET_PROJECTREPORT(state, data){
        state.projectReport = data
    }
}

const actions = {
    async fetchCards({commit}){
        try {
            let res = await getCards();
            commit('SET_CARDS', res.data);
        }
        catch (e){
            //
        }
    },
    async fetchWorking({commit}){
        try {
            let res = await getWorkingUser()
            commit('SET_WORKINGUSERS', res.data.data)
        }
        catch (e) {
            
            // throw e
        }
    },
    async fetchTimeSpentProjects({commit}){
        try {
            let res = await getTimeSpentProjects()
            commit('SET_TIMESPENTPROJECCTS', res.data)
        }
        catch (e) {
        //
        }
    },
    async fetchChartActivity({commit}, params){
        try {
            let res = await chartActivity(params)
            commit('SET_CHARTACTIVITY', res.data)
        }
        catch (e){
            
            
            // throw e
        }
    },
    async fetchSingleUserChart({commit}, params){
        try {
            let res = await chartActivitySingleUser(params)
            commit('SET_SINGLEUSERCHART', res)
        }
        catch (e){
            // throw e
        }
    },
    async fetchProjectReports({commit}, params){
        try {
            let res = await getTimeSpentProjects(params)
            commit('SET_PROJECTREPORT', res)
        }
        catch (e){
            //
        }
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

